import script from "./Notice.vue?vue&type=script&setup=true&lang=ts"
export * from "./Notice.vue?vue&type=script&setup=true&lang=ts"

import "./Notice.vue?vue&type=style&index=0&id=74bb9cd4&lang=scss&coped=true"

const __exports__ = script;

export default __exports__